module.exports = __webpack_public_path__ + "img/success.60c994d7.svg";